import { api } from 'shared';
import { z } from 'zod';

export const CateringEventCategoriesResponseSchema = z.object({
    data: z.array(
        z.object({
            documentId: z.string(),
            name: z.string(),
            slug: z.string(),
        }),
    ),
});
export const fetchCateringEventCategories = async () => (
    api.get<z.infer<typeof CateringEventCategoriesResponseSchema>>(
        '/catering-event-categories',
        {},
        CateringEventCategoriesResponseSchema,
    )
);
